// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1wBRH","title__footer":"footer_title__footer__oAw2G"};